var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSumWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 93.644 126.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5657",
    transform: "translate(-982.803 -1766.876)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 904",
    cx: 37.489,
    cy: 3.491,
    rx: 37.489,
    ry: 3.491,
    transform: "translate(992.149 1886.147)",
    fill: "#3db0f7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5652"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2026",
    d: "M1076.446 1811.047c0-24.395-20.95-44.171-46.793-44.171s-46.793 19.776-46.793 44.171c0 0-3.613 29.088 46.612 77.928 45.871-44.316 47.125-72.369 46.964-77.185.005-.248.01-.495.01-.743zm-46.974 28.011a28.73 28.73 0 1128.907-28.729 28.818 28.818 0 01-28.907 28.729z",
    fill: "#00AFF0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2027",
    d: "M1076.295 1811.047c0-24.395-20.95-44.171-46.793-44.171h-.181v14.722a28.73 28.73 0 110 57.458v49.92c45.871-44.316 47.125-72.369 46.964-77.185.004-.249.01-.496.01-.744z",
    fill: "#00AFF0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Location (Work)",
    transform: "translate(1015.073 1794.269)",
    fill: "#00AFF0"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2028",
    d: "M27.331 28.675H1.344A1.344 1.344 0 010 27.331V1.344A1.344 1.344 0 011.344 0h6.273a1.344 1.344 0 011.344 1.344v12.03l7.953-3.618a1.344 1.344 0 011.9 1.221v2.4l7.953-3.618a1.344 1.344 0 011.9 1.221v16.351a1.344 1.344 0 01-1.336 1.344zM2.688 25.987h23.3V13.061l-7.953 3.618a1.344 1.344 0 01-1.9-1.221v-2.4l-7.958 3.621a1.344 1.344 0 01-1.9-1.221V2.688H2.688z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 208",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(7.927 19.731)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 209",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(12.927 19.731)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 210",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(18.927 19.731)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumWork);
export default __webpack_public_path__ + "static/media/sum_work.31f92c7b31dced92748abd662d17344e.svg";
export { ForwardRef as ReactComponent };